module.exports = __webpack_public_path__ + "img/header2.65dab2dc.svg";